export enum LinkOpenMode {
  Inline = 'inline',      // Innerhalb der App in einer WebView
  Stack = 'stack',        // Intern in der App-Navigation
  External = 'external'   // Extern im System-Browser
}